import React from 'react';
import { PageHeader, CTASmall } from '../components/PageBits';
import { ASSET } from '../mock/data';
import { Eye, Compass, Users, GraduationCap, Heart, Sparkles, Target, Globe2 } from 'lucide-react';

const focusAreas = [
  { icon: Users, title: 'Community Empowerment', desc: 'Supporting people with the resources, confidence, and networks they need to move forward.' },
  { icon: GraduationCap, title: 'Education Support', desc: 'Encouraging deserving students through scholarships, mentoring, and community-backed assistance.' },
  { icon: Heart, title: "Women's Leadership", desc: 'Creating spaces where women are heard, recognized, equipped, and celebrated.' },
  { icon: Sparkles, title: 'Youth Participation', desc: 'Mobilizing young people to lead with service, discipline, creativity, and responsibility.' },
  { icon: Globe2, title: 'Cultural Continuity', desc: 'Preserving heritage while building inclusive spaces for future generations.' },
  { icon: Target, title: 'Social Responsibility', desc: 'Responding to community needs with empathy, transparency, and action.' },
];

const VisionMission = () => (
  <>
    <PageHeader kicker="Our Vision & Mission" title="A future shaped by" accent="compassion and collective action." intro="REFOCC's vision and mission guide every programme, gathering, and act of service. The organization works to uplift communities, empower individuals, and respond to social challenges with thoughtful, people-centered solutions." />
    <section className="py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-6">
        <div className="bg-refocc-dark text-refocc-cream rounded-[2rem] p-10">
          <Eye className="text-refocc-orange mb-5" size={32}/>
          <h2 className="font-serif text-3xl mb-4">Our Vision</h2>
          <p className="text-refocc-cream/80 leading-relaxed">To build a world where compassion, unity, cultural pride, and empowerment are part of everyday life, and where every individual has the dignity, support, and opportunity to thrive.</p>
        </div>
        <div className="bg-white border border-refocc-dark/10 rounded-[2rem] p-10">
          <Compass className="text-refocc-orange mb-5" size={32}/>
          <h2 className="font-serif text-3xl text-refocc-dark mb-4">Our Mission</h2>
          <p className="text-refocc-dark/70 leading-relaxed">To empower communities, uplift individuals, and address social challenges through innovative solutions, collaborative action, and sustained community engagement at both local and global levels.</p>
        </div>
      </div>
    </section>
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-serif text-4xl text-refocc-dark text-center mb-12">What we move towards</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {focusAreas.map(m => (
            <div key={m.title} className="flex gap-5 bg-white rounded-2xl p-6 border border-refocc-dark/10">
              <div className="w-14 h-14 rounded-full bg-refocc-orange/15 text-refocc-orange flex items-center justify-center shrink-0"><m.icon size={22}/></div>
              <div>
                <h3 className="font-serif text-xl text-refocc-dark">{m.title}</h3>
                <p className="text-sm text-refocc-dark/65 mt-1.5 leading-relaxed">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    <section className="py-20 bg-refocc-cream">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <img src={`${ASSET}/summit-02.jpg`} alt="REFOCC Summit" className="w-full rounded-[2rem] aspect-[16/7] object-cover mb-10" />
        <h2 className="font-serif text-4xl text-refocc-dark text-center mb-5">Walk with us</h2>
        <p className="text-center text-refocc-dark/70 max-w-xl mx-auto mb-8">Vision becomes reality when more hands join the work. Volunteer, sponsor, or simply spread the word.</p>
        <div className="text-center"><CTASmall /></div>
      </div>
    </section>
  </>
);

export default VisionMission;
